<template>
  <div class="container mb-5 flex-row items-center gap-12 text-justify md:flex md:items-start">
    <div class="mb-5 w-full leading-relaxed md:w-1/2">
      <p class="mb-2 leading-relaxed">
        La direttrice Teresa Gialdroni ringrazia l'Accademia Nazionale di S. Cecilia, il Presidente Sovrintendente
        Michele dall'Ongaro, il responsabile delle attività scientifiche Renato Meucci per il sostegno e tutto lo staff
        che ha contribuito con professionalità al raggiungimento di questo risultato, in particolare Cecilia Nanni e
        Giacomo Sciommeri (redattore). Si ringraziano inoltre i membri del comitato scientifico e i reviewers anonimi
        che hanno garantito il mantenimento di un livello sempre alto dei contributi pubblicati.
      </p>

      <p class="leading-relaxed">
        Studi Musicali è una rivista dell'Accademia Nazionale di Santa Cecilia dedicata alle discipline musicali e
        musicologiche. Fondata nel 1972 da Guido M. Gatti, è stata diretta dal 1977 al 1998 da Nino Pirrotta,
        successivamente da Bruno Cagli e dal 2001 al 2017 da Agostino Ziino.
      </p>
    </div>

    <div class="mb-5 w-full leading-relaxed md:w-1/2">
      <p class="leading-relaxed">
        La rivista «Studi musicali» ha il piacere di presentare il suo nuovo sito e le nuove potenzialità di accesso ai
        suoi contenuti. Il nostro periodico ha inaugurato una nuova fase, introducendo una rivoluzionaria innovazione
        che promette di trasformare radicalmente il modo in cui i lettori interagiscono con il sapere scientifico: la
        possibilità di "dialogare" con gli articoli grazie all'intelligenza artificiale. Sofisticati algoritmi rendono
        possibile porre domande dirette agli articoli, richiedere chiarimenti su specifici passaggi, esplorare
        connessioni con altre pubblicazioni e persino ottenere sintesi personalizzate in base ai propri interessi.
        Questa innovazione non solo democratizza l'accesso alla conoscenza, rendendola più comprensibile e fruibile
        anche per un pubblico non specialistico, ma apre anche nuove prospettive per la ricerca stessa, ponendo la
        nostra rivista all'avanguardia nel panorama internazionale.
      </p>
    </div>
  </div>
</template>
